import { mergeStyles } from '@cian/utils';
import { InlineText2, InlineText3 } from '@cian/ui-kit/typography/InlineText';

import * as React from 'react';

import { Tooltip } from '../../../../../../common/Tooltip';
import { IconHelp } from '../../../../../../UI/Icons/IconHelp';

import * as styles from './CustomFormField.css';
import { ICustomFormFieldProps } from './types';

export const CustomFormField: React.FC<ICustomFormFieldProps> = props => {
  const {
    label,
    children,
    containerClassName,
    errorMessage,
    required = false,
    isMobile = false,
    hidden = false,
    fullWidth = false,
    tooltipContent = null,
  } = props;

  if (hidden) {
    return null;
  }

  const ErrorInlineText = isMobile ? InlineText3 : InlineText2;

  return (
    <div
      className={
        mergeStyles(
          styles['container'],
          isMobile && styles['mobile'],
          containerClassName,
          fullWidth && styles['full-width'],
        ).className
      }
    >
      <div className={mergeStyles(styles['label-container'], required && styles['required']).className}>
        <InlineText2 as="span" color="black_100" fontWeight="normal">
          {label}
        </InlineText2>

        {tooltipContent && (
          <Tooltip content={tooltipContent}>
            <IconHelp className={styles['tooltip']} />
          </Tooltip>
        )}
      </div>
      <div className={styles['field']}>
        {children}
        {errorMessage && (
          <div className={styles['error-message-container']}>
            <ErrorInlineText as="span" color={isMobile ? 'error_100' : 'white_100'} fontWeight="normal">
              {errorMessage}
            </ErrorInlineText>
          </div>
        )}
      </div>
    </div>
  );
};

CustomFormField.displayName = 'CustomFormField';
